import { useEffect } from 'react';
import { useParams } from 'react-router';
import ProveedorForm from '../../components/proveedores/ProveedorForm';
import { useCiudadesStore } from '../../stores/ciudades/ciudades.store';
import { useEstadosStore } from '../../stores/estados/estados.store';
import {
  useProveedoresStore,
  type ActualizarProveedor
} from '../../stores/proveedores/proveedores.store';

const EditarProveedor = () => {
  const paramId = useParams<{ id: string }>().id ?? '';
  const id = Number(paramId);
  const {
    current: proveedor,
    actualizar,
    cargarPorId,
    desactivar,
    activar
  } = useProveedoresStore((state) => state);

  const { actives: ciudades, cargarActivas: cargarCiudades } = useCiudadesStore((state) => state);
  const { actives: estados, cargarActivos: cargarEstados } = useEstadosStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
    cargarCiudades();
    cargarEstados();
  }, [id]);

  const handleSave = (values: ActualizarProveedor) => {
    return actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const handleActivate = async () => {
    await activar(id);
  };

  return (
    <ProveedorForm
      proveedor={proveedor}
      ciudades={ciudades}
      estados={estados}
      onSave={handleSave}
      onDelete={handleDelete}
      onActivate={handleActivate}
      reloadCiudades={cargarCiudades}
    />
  );
};

export default EditarProveedor;
